var exports = {
  "Vw": "pinnedField__RKGHKt",
  "Mi": "colorFlash__3LPpx-",
  "nu": "animationClass__2pEO95",
  "FY": "animationFirst__sUax4S",
  "WG": "animationMiddle__somtp1",
  "hQ": "animationLast__Ex-C7f",
  "zU": "animationOnly__rVNTL5",
  "Gg": "compactSectionHeader__-dTMWQ",
  "VY": "compactSectionEmptyText__FaujCr",
  "tk": "loadingRow__HpuX4C",
  "YT": "sectionHeaderWrapper__8zdKMB",
  "zI": "setupFieldsLink__yae47q",
};

module.exports = exports;
